import type { SortDirection } from '@tanstack/react-table';
import { ChevronDown, ChevronsUpDown, ChevronUp } from 'lucide-react';
import { cn } from '@/utils/ui-utils';

const ICONS = { asc: ChevronUp, desc: ChevronDown } as const;

interface SortIndicatorProps {
  isSorted: false | SortDirection;
  className?: string;
}

const SortIndicator = ({ isSorted, className }: SortIndicatorProps) => {
  const Icon = isSorted ? ICONS[isSorted] : ChevronsUpDown;

  return (
    <span
      aria-hidden
      className={cn('inline-flex items-center justify-center', className)}
    >
      <Icon
        strokeWidth={2}
        size={10}
      />
    </span>
  );
};

export default SortIndicator;
